const onboardingServiceConfig = {
    getAllSections : `all-sections`,
    getUserSectionWithProgress :`user-sections`,
    getSectionById : `section`, //also for create, remove, update 
    reorderSections : `section-reorder`,
    createRemoveSectionProgress:'section-progress',
    allSectionProgress: 'all-section-progress',
    sectionProgressByUser: 'section-progress-by-user',
    userProgressBySection: 'user-progress-by-section',
};


export default onboardingServiceConfig;